module.exports = __webpack_public_path__ + "service-request-image.9866b5ee1f742d89b7a7.svg";


//////////////////
// WEBPACK FOOTER
// C:/unnati/latestWebCode29march/src/assets/images/service-request-image.svg
// module id = ../../../../../src/assets/images/service-request-image.svg
// module chunks = main